$(function() {
    // $('.lazy').lazy(); // Removed: using native loading="lazy"
});

$(document).ready(function(){

    var winW = $(window).width();

	// Header

  var barraH = $('.bar-mes').outerHeight();
  var infoH = $('.barra').outerHeight();
  var headerH = $('header').outerHeight();

  $(window).load(function(){
    var barraH = $('.bar-mes').outerHeight();
    var infoH = $('.barra').outerHeight();
    var headerH = $('header').outerHeight();
  });

  if ( winW > 830 ) {

    $('body').css('padding-top', barraH + infoH + headerH);
    $('header').css('top', barraH + infoH);
    $('.barra').css('top', barraH);

    $(window).scroll(function(){
      if ($(window).scrollTop() > barraH + infoH) {
        $('header').addClass('fix');
      } else {
        $('header').removeClass('fix');
        $('header').css('top', barraH + infoH);
      }
    });

  } else {

    var padTop = barraH + headerH;
    console.log('padTop: ' + padTop);

    $('body').css('padding-top', padTop);
    $('header').css('top', barraH);

    $(window).scroll(function(){
      if ($(window).scrollTop() > barraH) {
        $('header').addClass('fix');
      } else {
        $('header').removeClass('fix');
        $('header').css('top', barraH);
      }
    });

  }

	$('header .icons li .search').click(function(){
		$('header .big-search').toggleClass('show');
        $('header .black-search').toggleClass('show');
	});

    $('header .big-search .cerrar-big-search').click(function(){
		$('header .big-search').toggleClass('show');
        $('header .black-search').toggleClass('show');
	});

	$('header .icons li .cart').click(function(){
		$('#minicart').addClass('show');
	});
	$('#minicart .cerrar').click(function(){
		$('#minicart').removeClass('show');
	});

	$('header .show-menu').click(function(){
		$('nav').addClass('show');
      console.log('click222!');
	});

	$('nav .top .cerrar').click(function(){
      console.log('click!');
		$('nav').removeClass('show');
      console.log('click!');
	});

  	// Product

    $('.product .deon > h3').each(function(){
      $(this).addClass('accor');
      $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
    })

    $('.product .deon h3').click(function(){
      $(this).toggleClass('active');
      $(this).next('.hide-info').toggleClass('show');
    });

  $('.featured-collection ul .item[data-id="5125822054535"]').remove();
  $('.featured-collection ul .item[data-id="5125823266951"]').remove();

    // Pop Up

    $('#popup .cerrar').click(function(){
      $('#popup').removeClass('show');
    });




    if ( winW < 830 ) {
      $('nav ul.menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
      $('nav ul.menu > li.site-nav--has-dropdown span.down').click(function(){
        $(this).toggleClass('active');
        $(this).parent().siblings().children('.sub-menu').removeClass('show');
        $(this).parent().children('.sub-menu').toggleClass('show');
      });
      $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
      $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown span.down').click(function(){
        $(this).toggleClass('active');
        $(this).parent().siblings().children('.sub-sub-menu').removeClass('show');
        $(this).parent().children('.sub-sub-menu').toggleClass('show');
      });
    }

    // Carrito
$('.carrito tbody tr[data-id="pack"]').each(function(){
  var proiden = $(this).data('packid');
});

var $tr   = $('.carrito tbody tr[data-id="pack"]'),
    items = {};

$tr.each(function() {
  items[$(this).data('packid')] = '';
});

for (item in items) {
  $tr.filter('[data-packid='+ item +']').first().append( "<td class='quitar quitar" + item + "' data-quitar='" + item + "'><span><i>+</i></span></p>");
  $tr.filter('[data-packid='+ item +']').last().addClass('ultimo');
}

$('.carrito tbody tr[data-id="pack"] td.quitar').on('click', function(){
  var toRemove   = $(this).data('quitar');
  var qty        = 0;
  var data       = { updates: {} };
  var itemsArray = $('.carrito tbody tr[data-packid="' + toRemove + '"]').map(function(i,v){
    return $(v).data('item');
  }).get();
  for (i = 0; i < itemsArray.length; i++) {
    data.updates[itemsArray[i]] = qty;
  }
  jQuery.post('/cart/update.js',
    data
  ).always(function() {
    // console.log( "finished" );
    location.reload();
  });
});

$('.pack-block .agregar .addtocart').click(function() {
  var pack_type = $(this).attr('data-pack-type'),
      iden      = Math.floor((Math.random() * 10000000000000000000) + 1), jqxhr, $array_items = [],
      cantidad  = 6,
      first_array = {};
  if (pack_type == 2) {
    cantidad = 10;
  }

  $(this).addClass('clicked');

  $('.pack-cart' + pack_type + ' .slots ul li input').each(function(index){
    var inputVal = $(this).val();
    if (first_array[inputVal] === undefined) {
      first_array[inputVal] = 1;
    } else {
      first_array[inputVal] += 1;
    }
  });

  $.each(first_array, function (i, data) {
    $array_items.push({
      quantity: data,
      id: i,
      properties: {
        'Caja': 'Pack de ' + cantidad,
        'Iden': 'packid' + iden
      }
    });
  });

  console.log($array_items);

  jqxhr = jQuery.ajax({
    type: "POST",
    url: '/cart/add.js',
    data: { items: $array_items },
    success: function(data) {
    },
    error: function(data) {
      // console.log(data.status);
      if (data.status == 422) {
        //$('.alertas').text(proName + ' no tiene stock disponible');
      }
    },
    async: true
  });

  jqxhr.always(function() {
    $('.pack-cart' + pack_type + ' .agregar .otra').addClass('show');
    $('.pack-cart' + pack_type + ' .agregar .addtocart').text('Ir a pagar ›');
    $('.pack-cart' + pack_type + ' .agregar .addtocart').click(function() {
      window.location.href = "/cart";
    });
    update_mini_cart(false, true);
  });
});

$('.pack-vars .add').click(function() {
  var val           = $(this).parent().attr('value');
  var proimg        = $(this).parent().attr('data-image');
  var package       = $(this).parent().parent().parent().parent().find('li.empty').first(),
      class_clicked = '.' + ($(this).parent().parent().parent().parent().attr('class')).replace(/\s/g, '.');
  $(package).removeClass('empty').addClass('full').find('.proimg').attr('src', proimg);
  console.log(class_clicked);
  $(package).children('input').val(val);
  if (!$(class_clicked + ' .slots ul li:nth-child(12)').hasClass("empty")) {
    $(class_clicked + ' .agregar .disable').fadeOut(1);
  } else {
    $(class_clicked + ' .agregar .disable').fadeIn(1);
  }
});

$('.pack-cart .quitar').click(function() {
  $(this).parent('li').addClass('empty').removeClass('full');
  $(this).siblings('input').val('');
  var parIndex      = $(this).parent('li').index() + 1,
      class_clicked = '.' + ($(this).parent().parent().parent().parent().attr('class')).replace(/\s/g, '.');
  // console.log('parIndex: ' + parIndex);
  if (!$(class_clicked + ' .slots ul li:nth-child(12)').hasClass("empty")) {
    $(class_clicked + ' .agregar .disable').fadeOut(1);
  } else {
    $(class_clicked + ' .agregar .disable').fadeIn(1);
  }
});



    /**
   * Escucha permanente para agregar productos, funciona para snippet
   * product-item.liquid
   *
   * @param object this  Contiene el objeto del elemento cliqueado.
   */
    $('body').on('click', '.item .addcart', function() {
      var proVar = $(this).data('product-id');
      var proQt = $(this).siblings('.sec-cantidad').children().children('input').val();
      console.log('proQt', proQt);
      if (proQt == undefined) {
          var newQt = 1;
          console.log('newQt1', newQt);
      } else {
        var newQt = parseInt(proQt);
        console.log('newQt2', newQt);
      }
      jQuery.ajax({
        type: "POST",
        url: '/cart/add.js',
        data: {
          quantity: newQt,
          id: proVar
        },
        success: function(data) {
        },
        error: function(data) {
          if (data.status == 422) {
            $('.item-' + proVar + ' .alertas').text('Sin stock disponible');
          }
        },
        async: false
      });
      update_mini_cart(true);
    });

});

/**
 * Escucha permanente para borrar producto del mini carro
 *
 * @param object this  Contiene el objeto del elemento cliqueado.
 */
$('body').on('click', '#minicart .middle .left i.delete-prod', function() {
  var var_this = this;
  Shopify.removeItem($(this).data('id'), function() {
    $(var_this).css("margin", "0").parent().parent().slideUp(200);
    update_mini_cart(false, false);
  });
});

/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
function update_mini_cart(show = false, all = true) {
  if (all) {
    $('#minicart .middle ul').empty();
  }
  $("#minicart .cifra").empty();
  jQuery.get("/cart.js", function(data) {
    for (var i = 0; i < data.items.length; i++) {
      var titulo     = data.items[i]["product_title"];
      var varianteID = data.items[i]["variant_id"];
      var precio     = data.items[i]["price"] ? parseFloat(data.items[i]["price"]).toString().substring(0, parseFloat(data.items[i]["price"]).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      var cantidad   = data.items[i]["quantity"];
      var imagen     = data.items[i]["image"];
      var proMini    = "<li><div class='left'><i class='delete-prod' data-id='" + varianteID + "'></i><h4>" + titulo + "</h4><h5>$" + precio + "</h5><h6>Cantidad: <span>" + cantidad + "</span></h6></div><div class='right'><img src='" + imagen + "' alt='' /></div></li>";
      if (all) {
        $("#minicart .middle ul").append(proMini);
      }
    }
    var total     = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var itemcount = data.item_count;
    $("#minicart .cifra").append('$' + total);
    $("header .icons li a.cart .count").html(itemcount);
    if (show) {
      $('#minicart').addClass('show');
    }
  }, 'json');
}

/**
 * Si en algún momento hay errores de carga de jQuery.
 * Uso: defer(function () { //= acá va la funcion =// });
 *
 * @param object method  Funcion completa a ejecutar
 */
function defer(method) {
  if (window.jQuery) {
    method();
  } else {
    setTimeout(function() { defer(method) }, 50);
  }
}
